// RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children }) => {
  // Adjust this condition based on how you store login
  const isLoggedIn =
    sessionStorage.getItem("loggedIn") === "true" ||
    !!sessionStorage.getItem("q2p_token");

  const location = useLocation();

  if (!isLoggedIn) {
    return (
      <Navigate
        to="/login"
        state={{ ...location?.state, from: location }}
        replace
      />
    );
  }

  return children;
};

export default RequireAuth;
